module.exports = __webpack_public_path__ + "static/media/antano-pan-diario-80g-800x800.9ac5b502.webp";